import { render } from "./SolutionsReference.vue?vue&type=template&id=3d0a6e0f&lang=pug"
import script from "./SolutionsReference.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionsReference.vue?vue&type=script&setup=true&lang=js"

import "./SolutionsReference.vue?vue&type=style&index=0&id=3d0a6e0f&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__